var Transition = {
  beforeEnter(el) {
    el.style.transition = "all 0.6s ease";
    el.style.height = "0px";
    el.style.opacity = 0;
    el.style.overflow = "hidden";
  },

  enter(el) {
    var height = el.scrollHeight ;
    el.style.opacity = 1;
    el.style.height = height + "px";
  },

  afterEnter(el) {
    el.style.overflow = "visibility";
  },

  beforeLeave(el) {
    el.style.overflow = "hidden";
  },

  leave(el) {
    el.style.transition = "all 0.6s ";
    el.style.opacity = 0;
    el.style.height = "0px";
  }
};

export default {
  name: "slideDown",
  functional: true,
  render(h, { children }) {
    const data = {
      on: Transition
    };
    return h("transition", data, children);
  }
};



// WEBPACK FOOTER //
// ./src/common/js/slideDown.js